<template>
    <div style="margin-bottom: 60px; margin-top: 60px">
        <div class="columns">
            <div class="column is-8 is-offset-2">
                <div class="box p-2">
                    <h1 class="title is-3 has-text-centered"
                        style="margin-bottom: 40px">
                        500 Server Error
                    </h1>
                    <p class="lead">
                        An error occurred while we were processing your request. Please contact us at admin@imagesim.com
                        and provide the error code below to help identify the issue.
                    </p>
                    <p class="lead">Error Code: 6545</p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {}
</script>